export default __webpack_public_path__ + "static/media/logo.fb847ef5.png";